/* global axios */
import ApiClient from './ApiClient';

class InboxMembers extends ApiClient {
  constructor() {
    super('inbox_members', { accountScoped: true });
  }

  update({ inboxId, agentList, teamLeaderList, viewDataUserList }) {
    return axios.patch(this.url, {
      inbox_id: inboxId,
      user_ids: agentList,
      team_leader_ids: teamLeaderList,
      view_data_ids: viewDataUserList,
    });
  }
}

export default new InboxMembers();
